import { Component, Inject, InjectionToken, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ProductColorModel, ProductModel, ProductParamModel, ProductTypeModel } from './model/product.model';
import { switchMap } from 'rxjs/operators';
import { ServerErrorMessage } from './admin/login/login.component';
import { FileService } from './services/file.service';
import { ProductTypeService } from './services/product-type.service';
import { ProductColorService } from './services/product-color.service';
import { ProductService } from './services/product.service';
import { ProductParamService } from './services/product-param.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SwalService } from './shared/swal.service';
import { HelperService } from './services/helper.service';

export const CURRENT_DATA = new InjectionToken<any>('currentData');

@Component({
  selector: 'app-root',
  template: '' +
  '<router-outlet></router-outlet>' +
  '<ngx-spinner type="ball-circus"></ngx-spinner>' +
  ''
})
export class AppComponent implements OnInit {

  constructor(
    @Inject(CURRENT_DATA) private currentDataSubject: BehaviorSubject<any>,
    private spinner: NgxSpinnerService,
    private swalService: SwalService,
    private helper: HelperService,

    private fileService: FileService,
    private productTypeService: ProductTypeService,
    private productColorService: ProductColorService,
    private productService: ProductService,
    private productParamService: ProductParamService
  ) {
  }

  ngOnInit() {
    let colors: Array<ProductColorModel> = [];
    let productTypes: Array<ProductTypeModel> = [];
    let productParams: Array<ProductParamModel> = [];
    let products: Array<ProductModel> = [];

    this.spinner.show();
    this.productTypeService.getList().pipe(
      switchMap((types: Array<ProductTypeModel>) => {
        productTypes = this.helper.sortByName(types);
        return this.productParamService.getList();
      }),
      switchMap((params: Array<ProductParamModel>) => {
        productParams = this.helper.sortProductParams(params.map(item => {
          return {
            ...item, ...{
              productType: productTypes.find(type => type.id === item.productTypeId)
            }
          };
        }));
        return this.productColorService.getList();
      }),
      switchMap((res: Array<ProductColorModel>) => {
        colors = res.map(item => ({...item, ...{
          params: item.params.map(param => ({...param, ...{
            productParam: productParams.find(val => val.id === param.productParamId)
          }}))
        }}));
        return this.productService.getList();
      })
    ).subscribe((res: Array<ProductModel>) => {
      this.spinner.hide();
      products = res.map(item => {
        return {...item, ...{
          productType: productTypes.find(type => type.id === item.productTypeId),
          colors: colors.filter(color => item.colorIds.includes(color.id)),
          selectedColorIndex: 0
        }};
      });
      products = this.helper.sortByName(products);

      this.currentDataSubject.next({
        productTypes,
        productParams,
        products
      });
    }, () => {
      this.spinner.hide();
      this.swalService.openErrorMessage(ServerErrorMessage);
    });
  }

}
